class PremiumMainCollection extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.sortSelect = this.querySelector('[data-pmc-sort]');
    this.sortSelect?.addEventListener('change', this.onSortChange, { signal: this.signal });
    window.addEventListener('pageshow', this.onPageShow, { signal: this.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onSortChange = () => {
    if (!this.sortSelect?.value) return;
    this.classList.add('is-sorting');
    this.sortSelect.disabled = true;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.sortSelect.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  };

  onPageShow = () => {
    this.classList.remove('is-sorting');
    if (this.sortSelect) this.sortSelect.disabled = false;
  };
}

if (!customElements.get('premium-main-collection')) {
  customElements.define('premium-main-collection', PremiumMainCollection);
}
